import { useContext, useState } from "react";
import Full_Screen_Modal from "../../../../full-screen-modal/Full_Screen_Modal";
import { Success_Lottie } from "../../../../lotties/success-lottie/Success_Lottie";
import "./Review_Booking.css";
import { useNavigate } from "react-router-dom";
import Edit_Trip_Modal from "../../../../edit-trip-modal/Edit_Trip_Modal";
import Pickup_Modal from "../../../../pickup-modal/Pickup_Modal";
import Edit_Name_Modal from "../../../../edit-name-modal/Edit_Name_Modal";
import { Context } from "../../../../../utils/context";
import { formatAmount, formatDate, formatTime } from "../../../../../utils/common";
import useRazorpay from "react-razorpay";

const Review_Booking = ({ getBooking }) => {


  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  // Trip Modal State
  const [showTripModal, setShowTripModal] = useState(false);

  // Pickup Modal State
  const [showPickupModal, setShowPickupModal] = useState(false);

  // customer madal state
  const [showCustomerModal, setShowCustomerModal] = useState(false);

  const [customerData, setCustomerData] = useState({
    fullName: "Oshin Kawale",
    contactNumber: "+91 9876543210",
    email: "oshin.kawale@profcyma.com",
  });
  const navigate = useNavigate();

  const handleProceedToPay = () => {
    setShowPaymentModal(true);
    setTimeout(() => {
      setShowPaymentModal(false);
      navigate("/");
    }, 3000);
  };

  const [showModal, setShowModal] = useState(false);
  const handleSave = () => {
    setShowModal(false);
  };
  const [tripData, setTripData] = useState({
    tripType: "One-way trip",
    fromTo: "Alchi to Leh",
    itinerary: "Alchi - Leh",
    distance: "68 km",
    tripDate: "2026-02-12",
    cabCategory: "Luxury",
    occupancy: "2 passengers and 1 driver",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTripData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [pickupData, setPickupData] = useState({
    time: "08:30",
    date: "2026-02-12",
    location: "Alchi monastery",
  });



  const [Razorpay] = useRazorpay();

  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Infinity Ladakh",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        // await setRazorId(res.razorpay_payment_id);
        await onSubmit(res.razorpay_payment_id);
      },
      prefill: {
        name: "Prajwal Vaychal",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#ffe600",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const onSubmit = async (payment_id) => {
    console.log("Form Data:", payment_id);
    const formData = new FormData();

    formData.append("payment_id", payment_id);


    const response = await postData(`/without-login/booking/step-1/${BookingData?.id}`, formData);
    console.log({ response });

    if (response?.success) {
      // setTimeout(() => {
      await handleProceedToPay();
      // }, 2500);
    } else {
      // setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };
  return (
    <section className="review_booking_container">
      <div className="booking_card">
        <div className="row">
          <div className="col-lg-10">
            <div className="info_row">
              <span>Trip Type</span>
              <span>:</span>
              <span>{BookingData?.trip_type === "drop" ? "One-way trip" : "Tour"}</span>
            </div>
            <div className="info_row">
              <span>From - To</span>
              <span>:</span>
              <span>{BookingData?.location?.name ?? "Pickup Location"} - {BookingData?.destinationDescription ?? "Drop Location"}</span>
            </div>
            <div className="info_row">
              <span>Itinerary </span>
              <span>:</span>
              <span>{BookingData?.location?.name ?? "Pickup Location"} - {BookingData?.destinationDescription ?? "Drop Location"}</span>
            </div>
            {/* <div className="info_row">
              <span>Total Distance </span>
              <span>:</span>
              <span>68 km</span>
            </div> */}
            <div className="info_row">
              <span>Trip Date</span>
              <span>:</span>
              <span>{formatDate(BookingData?.date)} </span>
            </div>
            <div className="info_row">
              <span>Cab Category </span>
              <span>:</span>
              <span>{BookingData?.cab_type?.cab_category?.name || ""}</span>
            </div>
            <div className="info_row">
              <span>Occupancy </span>
              <span>:</span>
              <span>{BookingData?.cab_type?.seat_capacity?.name || "2"} passengers and 1 driver</span>
            </div>
            <div className="info_row">
              <span>Private Taxi </span>
              <span>:</span>
              <span>
                The taxi is only for you, it will not be shared with other
                passengers
              </span>
            </div>
          </div>
          <div className="col-lg-2 text-end">
            <a className="edit_link" onClick={() => setShowTripModal(true)}>
              Edit
            </a>
          </div>
        </div>
      </div>

      <div className="booking_card">
        <div className="row">
          <div className="col-lg-10">
            <div className="info_row">
              <span>Pick-up Time</span>
              <span>:</span>
              <span>{formatTime(BookingData?.time)} on {formatDate(BookingData?.date)}</span>
            </div>

            <div className="info_row">
              <span>Pick-up from</span>
              <span>:</span>
              <span>{BookingData?.pickup_location || ""}</span>
            </div>
          </div>

          <div className="col-lg-2 text-end">
            <a className="edit_link" onClick={() => setShowPickupModal(true)}>
              Edit
            </a>
          </div>
        </div>
      </div>

      <div className="booking_card">
        <div className="row">
          <div className="col-lg-10">
            <div className="info_row">
              <span>Full Name </span>
              <span>:</span>
              <span>
                {[BookingData?.user?.first_name, BookingData?.user?.last_name]
                  .filter(Boolean)
                  .join(" ")}
              </span>            </div>

            <div className="info_row">
              <span>Contact Number</span>
              <span>:</span>
              <span> {BookingData?.user?.contact_no || ""}</span>
            </div>

            <div className="info_row">
              <span>Email Id </span>
              <span>:</span>
              <span className="cust_email"> {BookingData?.user?.email || ""}</span>
            </div>
          </div>

          <div className="col-lg-2 text-end">
            <a className="edit_link" onClick={() => setShowCustomerModal(true)}>
              Edit
            </a>
          </div>
        </div>
      </div>

      <div className="review_booking_footer">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-5 order-lg-1 order-md-1 order-2">
            <div className="footer_img_holder">
              <img
                src="/assets/images/home/banner/book-a-ride/payment.png"
                alt="footer-img"
                className="footer_img"
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 order-lg-2 order-md-2 ">
            <div className="footer_right_div">
              <div className="dark_div">
                <p className="amount">Total Amount:</p>
                <h5 className="total">{formatAmount(BookingData?.fare)}</h5>
              </div>
              {/* <div className="yellow_div" onClick={handleProceedToPay}> */}
              <div className="yellow_div" onClick={() => handleRazorpay(BookingData?.fare)}>
                Proceed to Pay
              </div>
            </div>
          </div>
        </div>
      </div>

      <Full_Screen_Modal
        show={showPaymentModal}
        onHide={() => showPaymentModal(false)}
        lottie={<Success_Lottie />}
      />

      <Edit_Trip_Modal
        show={showTripModal}
        handleClose={() => setShowTripModal(false)}
        tripData={tripData}
        handleChange={handleChange}
        handleSave={() => { getBooking(); setShowTripModal(false) }}
      />

      <Pickup_Modal
        getBooking={getBooking}
        show={showPickupModal}
        handleClose={() => { getBooking(); setShowPickupModal(false) }}
        pickupData={pickupData}
        handleUpdate={setPickupData}
      />

      <Edit_Name_Modal
        getBooking={getBooking}

        show={showCustomerModal}
        handleClose={() => { getBooking(); setShowCustomerModal(false) }}
        customerData={customerData}
        handleUpdate={setCustomerData}
      />
    </section>
  );
};

export default Review_Booking;
